export default __webpack_public_path__ + "media/276fd829526f6208c333a3c479a9274ca850df751318c369d082c9237fd95717.svg";